<template>
  <div class="album_wrap">
    <div class="album">
      <page-header class="not_main"></page-header>
      <div class="album_content">
        <image-component :infoType="`albumBanner`"></image-component>
        <div class="album_content_block">
          <board-list-component :boardType="'album'"></board-list-component>
        </div>
      </div>
      <page-footer class="not_main"></page-footer>
    </div>
  </div>
</template>

<script>
import ImageComponent from "@/components/information/ImageComponent";
import BoardListComponent from "@/components/board/BoardListComponent";

export default {
  name: "Album",
  mixins: [],
  components: {BoardListComponent, ImageComponent},
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {}
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {},
  watch: {},
}
</script>

<style scoped>

</style>